import {COMPANY_NAME} from '@joyrideautos/auction-core/src/constants/Constants';
import {CUSTOM_THEME} from '@joyrideautos/web-common-components/src/theme/constants';

export const SEARCH_TITLE = `Search ${COMPANY_NAME} for`;
export {CUSTOM_THEME};
